import { render, staticRenderFns } from "./pickup.vue?vue&type=template&id=21056fe2"
import script from "./pickup.vue?vue&type=script&lang=ts"
export * from "./pickup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports